import React, { useEffect, useState } from 'react';
import { useQuery } from "react-query";
import axios from "axios";
import tw from 'tailwind-styled-components';
import { useParams, useNavigate, useLocation } from 'react-router-dom';
import { useSelector, useDispatch } from "react-redux";
import { Set_Cart_Modal_Open } from '../Redux/actions';
import Product from '../components/Product';
import Cart from '../components/Cart';
import Config from '../Config';
import EmailLoginModal from '../components/EmailLoginModal';
import LoginModal from './User/Login';
import SignupModal from './User/Register';
import { FaArrowLeft, FaShoppingCart } from 'react-icons/fa';
import { ProductLoading } from '../components/SkeletonLoading/ProductsLoading';

function AllProducts() {
    const navigate = useNavigate();
    const location = useLocation();
    const dispatch = useDispatch();
    const { type } = useParams(); // all-products, latest, under1000, sneakers, personalized-picks, new-arrivals

    const searchParams = new URLSearchParams(location.search);
    const searchQuery = searchParams.get('q');
    const queryCategoryId = searchParams.get('category_id');
    const querySectionTitle = searchParams.get('title');

    const state = location.state || {};
    const categoryId = queryCategoryId || state.categoryId;
    const sectionTitle = querySectionTitle || state.sectionTitle;

    const user = useSelector((state) => state.UserReducer.user);
    const isCartModalOpen = useSelector((state) => state.CartReducer.isCartModalOpen);

    const [isLoginModalOpen, setIsLoginModalOpen] = useState(false);
    const [isOTPLoginModalOpen, setIsOTPLoginModalOpen] = useState(false);
    const [isSignupModalOpen, setIsSignupModalOpen] = useState(false);

    const getPageTitle = () => {
        if (sectionTitle) return sectionTitle;

        switch (type) {
            case 'search':
                return `Search Results for "${searchQuery || ''}"`;
            case 'all-products':
                return 'All Products';
            case 'personalized-picks':
                return 'Personalized Picks';
            case 'new-arrivals':
                return 'New Arrivals';
            case 'latest':
                return 'Latest Products For You';
            case 'under1000':
                return 'Products Under ₹1000';
            case 'sneakers':
                return 'Trending in Sneakers';
            default:
                return 'Products';
        }
    };

    const fetchProducts = async () => {
        let url = '';

        switch (type) {
            case 'search':
                url = `${Config.apiUrl}/products/search?q=${searchQuery}`;
                break;
            case 'all-products':
                // Fetch all products for the specific category or all categories
                url = categoryId
                    ? `${Config.apiUrl}/products?category_id=${categoryId}&limit=99`
                    : `${Config.apiUrl}/products?limit=99`;
                break;
            case 'personalized-picks':
                url = categoryId
                    ? `${Config.apiUrl}/products?category_id=${categoryId}&limit=99`
                    : `${Config.apiUrl}/products?limit=99`;
                break;
            case 'new-arrivals':
                url = categoryId
                    ? `${Config.apiUrl}/products?category_id=${categoryId}&limit=99`
                    : `${Config.apiUrl}/products?limit=99`;
                break;
            case 'latest':
                // Fetch all latest products
                url = `${Config.apiUrl}/products/?sort_order=DESC&sorted_by=created_at&limit=99`;
                break;
            case 'under1000':
                // Fetch all products under 1000
                url = `${Config.apiUrl}/products/?max_price=1000&sort_order=DESC&limit=99`;
                break;
            case 'sneakers':
                // Fetch all sneakers (category_id=1)
                url = `${Config.apiUrl}/products/?category_id=1&sort_order=DESC&limit=99`;
                break;
            default:
                // Fetch all products
                url = `${Config.apiUrl}/products?limit=99`;
        }

        // console.log('Fetching all products from URL:', url);
        return await axios.get(url);
    };

    const { isLoading, error, data } = useQuery(
        [`fetchProducts-${type}`, categoryId, searchQuery],
        fetchProducts,
        {
            enabled: !!type
        }
    );

    const products = data?.data?.data?.products || [];

    // const handleBack = () => {
    //     navigate('/categories');
    // };


    const handleOpenCartModal = () => {
        if (user) {
            dispatch(Set_Cart_Modal_Open(true));
        } else {
            setIsLoginModalOpen(true);
        }
    };

    if (error) {
        return (
            <PageContainer>
                <TopNavbar>
                    <BackButton onClick={() => navigate(-1)}>
                        <FaArrowLeft className="w-6 h-6" />
                    </BackButton>
                    <PageTitle>All Products</PageTitle>
                    <CartButton onClick={handleOpenCartModal}>
                        <FaShoppingCart className="w-6 h-6" />
                    </CartButton>
                </TopNavbar>
                <ErrorContainer>
                    <ErrorText>Failed to load products. Please try again.</ErrorText>
                </ErrorContainer>
            </PageContainer>
        );
    }

    return (
        <PageContainer>
            <TopNavbar>
                <BackButton onClick={() => navigate(-1)}>
                    <FaArrowLeft className="w-6 h-6" />
                </BackButton>
                <PageTitle>{getPageTitle()}</PageTitle>
                <CartButton onClick={handleOpenCartModal}>
                    <FaShoppingCart className="w-6 h-6" />
                </CartButton>
            </TopNavbar>

            <ContentContainer>
                {isLoading ? (
                    <ProductLoading count={24} />
                ) : products.length > 0 ? (
                    <>
                        <ProductCount>
                            {products.length} Product{products.length !== 1 ? 's' : ''}
                            {type === 'all-products' || type === 'personalized-picks' || type === 'new-arrivals' && categoryId ? ' found in this category' : ' found'}
                        </ProductCount>

                        <Product
                            products={products}
                            onOpenLoginModal={() => setIsLoginModalOpen(true)}
                            onOpenCartModal={() => dispatch(Set_Cart_Modal_Open(true))}
                        />
                        <ViewAll onClick={() => navigate('/categories')}>
                            Explore All Categories
                        </ViewAll>
                    </>
                ) : (
                    <EmptyContainer>
                        <EmptyText>
                            No products found
                            {/* {type === 'under1000' && ' under ₹1000'}
                            {type === 'sneakers' && ' in sneakers'}
                            {type === 'latest' && ' in latest products'}
                            {type === 'all-products' && categoryId && ' in this category'}
                            {type === 'personalized-picks' && categoryId && ' in personalized-picks products'}
                            {type === 'new-arrivals' && categoryId && ' in new arrivals'} */}
                            .
                        </EmptyText>
                        <ViewAll onClick={() => navigate('/categories')}>
                            Explore All Categories
                        </ViewAll>
                    </EmptyContainer>
                )}
            </ContentContainer>

            {/* Modals */}
            <EmailLoginModal
                isOpen={isLoginModalOpen}
                onClose={() => setIsLoginModalOpen(false)}
                onSwitchToSignup={() => {
                    setIsLoginModalOpen(false);
                    setIsSignupModalOpen(true);
                }}
                onSwitchToEmailLogin={() => {
                    setIsLoginModalOpen(false);
                    setIsOTPLoginModalOpen(true);
                }}
            />
            <LoginModal
                isOpen={isOTPLoginModalOpen}
                onClose={() => setIsOTPLoginModalOpen(false)}
                onSwitchToSignup={() => {
                    setIsOTPLoginModalOpen(false);
                    setIsSignupModalOpen(true);
                }}
            />
            <SignupModal
                isOpen={isSignupModalOpen}
                onClose={() => setIsSignupModalOpen(false)}
                onSwitchToLogin={() => {
                    setIsSignupModalOpen(false);
                    setIsLoginModalOpen(true);
                }}
            />
            <Cart
                isOpen={isCartModalOpen}
                onClose={() => dispatch(Set_Cart_Modal_Open(false))}
            />
        </PageContainer>
    );
}

// Styled Components
const PageContainer = tw.div`bg-white min-h-screen`;

const TopNavbar = tw.div`
    flex items-center justify-between 
    p-2 bg-white border-b border-gray-200
    sticky top-0 z-10
`;

const BackButton = tw.button`
   text-gray-600 hover:text-gray-900 p-2 rounded-lg hover:bg-gray-100 
    transition-colors duration-200
`;

const PageTitle = tw.h1`
    text-xl font-semibold text-gray-800 
    flex-1 text-center mx-4
`;

const CartButton = tw.button`
    p-2 rounded-full hover:bg-gray-100 
    transition-colors duration-200
`;

const ContentContainer = tw.div`p-1`;

const LoadingContainer = tw.div`
    flex justify-center items-center py-12
`;

const ErrorContainer = tw.div`
    flex justify-center items-center py-12
`;

const ErrorText = tw.p`
    text-center text-red-500 text-lg
`;

const ProductCount = tw.p`
    text-md text-gray-600 p-2 text-center
`;

const EmptyContainer = tw.div`
    flex flex-col items-center justify-center py-12
`;

const EmptyText = tw.p`
    text-gray-500 text-lg mb-4
`;

const BackToHomeButton = tw.button`
    px-6 py-2 bg-blue-600 text-white rounded-md 
    hover:bg-blue-700 transition-colors duration-200
`;

const ViewAll = tw.button`
  block mx-auto px-3 py-0.5 mb-2
  text-kuality-blue rounded-md 
  hover:text-kuality-dark transition-colors 
  text-md font-medium
`;

export default AllProducts;